import { render, staticRenderFns } from "./GoalsIndex.vue?vue&type=template&id=a37a9ab6"
import script from "./GoalsIndex.vue?vue&type=script&lang=js"
export * from "./GoalsIndex.vue?vue&type=script&lang=js"
import style0 from "./GoalsIndex.vue?vue&type=style&index=0&id=a37a9ab6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports